import {
  fetchListing,
} from '@/api/tag';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch(context, query = null) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    const pagination = query !== false;
    query = query === false ? null : query;
    return fetchListing(state.pagination.page, query, pagination)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        if (res.items && res.pagination) {
          commit('setResponse', res);
        }
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve tags',
          () => commit('reset')
        )
      )
    ;
  },
};
